module.exports = {
      id: "icon-pause-usage",
      viewBox: "0 0 17.726 22.137",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#icon-pause",
      toString: function () {
        return this.url;
      }
    }